import { useEffect, useRef } from 'react';

//set add an event listener for outside of given dom
export default function useOutsidOfDOMClick(callback, deps = undefined) {
    const domRef = useRef(null);

    useEffect(() => {
        function onOutsidOfDOMClick(e) {
            if (domRef.current.contains(e.target)) {
                return;
            }
    
            callback();
        }

        window.addEventListener('click', onOutsidOfDOMClick);
        return () => window.removeEventListener('click', onOutsidOfDOMClick);
    }, deps);

    return domRef;
}